import { useState } from 'react'
import { Info } from 'lucide-react'
import TimeTabs from './TimeTabs'
import StatsCards from './StatsCards'
import WeeklyChart from './WeeklyChart'
import KpiStats from './KpiStats'
import { useT } from '../../hooks/useTranslation'

export default function ProfitSection() {
  const t = useT()
  const [tooltip, setTooltip] = useState(false)

  return (
    <section className="mb-2" data-hint="trading-stats">
      <div className="flex items-center gap-2 mb-3" style={{ position: 'relative' }}>
        <h2 className="text-[17px] font-semibold text-white">{t.profit}</h2>

        <button
          onMouseEnter={() => setTooltip(true)}
          onMouseLeave={() => setTooltip(false)}
          onClick={() => setTooltip(v => !v)}
          style={{ display: 'flex', alignItems: 'center', padding: 10, margin: -10 }}
          aria-label="Profit info"
        >
          <Info size={15} color={tooltip ? '#34D399' : '#636366'} />
        </button>

        {tooltip && (
          <div
            style={{
              position: 'absolute',
              top: 'calc(100% + 8px)',
              left: 0,
              zIndex: 100,
              background: '#1C1C1E',
              border: '1px solid rgba(255,107,53,0.25)',
              borderRadius: 12,
              padding: '10px 14px',
              width: 250,
              boxShadow: '0 8px 32px rgba(0,0,0,0.6)',
            }}
          >
            {/* Arrow */}
            <div style={{
              position: 'absolute',
              top: -6,
              left: 22,
              width: 10,
              height: 10,
              background: '#1C1C1E',
              border: '1px solid rgba(255,107,53,0.25)',
              borderRight: 'none',
              borderBottom: 'none',
              transform: 'rotate(45deg)',
            }} />
            <p style={{ fontSize: 13, color: '#8E8E93', lineHeight: 1.55, margin: 0 }}>
              {t.profitTooltip}
            </p>
          </div>
        )}
      </div>

      <TimeTabs />
      <StatsCards />
      <WeeklyChart />
      <KpiStats />
    </section>
  )
}
